.Main {
    width: 100%;
    box-sizing: border-box;
    padding: var(--large-space) var(--space);
}

.Copyright {
    padding: var(--small-space) 0;
}

.Bottom {
    border-top: solid 2px currentColor;
    display: grid;
    grid-auto-flow: column;
    grid-gap: var(--space);
    padding: var(--small-space) 0 var(--small-space) 0;
}

.Items {
    display: grid;
    grid-auto-flow: row;
    grid-gap: var(--small-space);
}

.Items a {
    color: var(--fg);
}

.AlignRight {
    text-align: right;
}

.IsExternal a {
    border-bottom: solid 2px currentColor;
}

@media (min-width: 768px) {
    .Main {
        padding: 0 var(--space);
    }

    .Inner {
        border-top: solid 2px currentColor;
        display: grid;
        grid-template-columns: 1fr max-content;
        justify-content: space-between;
    }

    .Bottom {
        border: none;
        display: grid;
        grid-auto-flow: column;
        grid-gap: var(--space);
    }

    .Items {
        display: grid;
        grid-auto-flow: column;
        grid-gap: var(--space);
    }
}